import { baseUrl, baseUrlEnvironment,  baseUrlFrontOffice ,productName } from "services/constants";

export const singInPageData = {
  loginEndpoint: baseUrl + "/session/login-ib",
  page: {
    title: productName,
    form: {
      title: "Bienvenido",
      inputs: [
        {
          id: "email",
          type: "email",
          label: "Email",
          placeholder: "Ingresa tu dirección de email",
          error: false,
          validations: [
            {
              type: "required",
              errorMessage: "Ingresa tu dirección de email",
            },
            {
              type: "pattern",
              pattern: /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/,
              errorMessage: "Ingresa una dirección de email válida",
            },
          ],
        },
        {
          id: "password",
          type: "password",
          label: "Contraseña",
          placeholder: "Ingresa tu contraseña",
          error: false,
          validations: [
            {
              type: "required",
              errorMessage: "Ingresa tu contraseña",
            },
            {
              type: "minLength",
              count: 5,
              errorMessage: "La contraseña debe tener al menos 5 caracteres",
            },
          ],
        },
      ],
      forgotPassword: {
        label: "¿Olvidaste tu contraseña?",
        link: baseUrlFrontOffice + "/r/recovery-password",
      },
      submitButton: {
        text: "Iniciar Sesión",
      },
    },
    failed: {
      title: "¡Inicio de sesión fallido!",
      message:
        "No pudimos verificar tu cuenta de embajador. Por favor, asegúrate de usar una cuenta válida de embajador o intenta con el inicio de sesión regular.",
      button: "intentar nuevamente",
    },
  },
};
